import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

function PoliticaCard() {
  // Stato per gestire l'apertura/chiusura del premio
  const [showSalvadori, setShowSalvadori] = useState(false);

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col md={10}>
        <blockquote className="blockquote mb-0">
          
          {/* --- PARTI STATICHE (INVARIATE) --- */}
          
          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            Partito Nazional Canarista <img src="https://i.imgur.com/iqUAwgU.png" style={{ height: "50px"}} alt="logo" />
          </h2>
          <p style={{ textAlign: "center" }}>
            ● Congrega
          </p>
          <br />

          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            Equilibrium Party <img src="https://i.imgur.com/gbwgSDj.png" style={{ height: "50px"}} alt="logo" />
          </h2>
          <p style={{ textAlign: "center" }}>
            ● Equibriadores
          </p>
          <br />

          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            El Progreso <img src="https://i.imgur.com/HrcjZ0o.png" style={{ height: "50px"}} alt="logo" />
          </h2>
          <p style={{ textAlign: "center" }}>
            ● Attualmente Vice Segretario Generale
          </p>
          <br />

          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            Disegni di Legge
          </h2>
          <p style={{ textAlign: "center" }}>
            ● <a href="https://docs.google.com/document/d/1weRh0PlThIMf2_uDfEuSLTctFrBDAoIlKVjSRFZjVMs/edit?tab=t.0" target="_blank">Regolamento per l'Emittenza Televisiva (RET)</a>
          </p>
          <br />

          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            Autorità di Controllo Televisivo (ACT) <img 
                  src="https://i.imgur.com/pc8nMW3.png" 
                  style={{ height: "60px"}} 
                />   
          </h2>
          <p style={{ textAlign: "center" }}>
            ● Membro Permanente dall'11/12/2025 al 12/01/2026
          </p>
          <br />

          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            Assemblea Costituente
          </h2>
          <p style={{ textAlign: "center" }}>
            ● Membro dell'Assemblea Costituente in ambito della Pubblica Amministrazione
          </p>
          <br />

          {/* --- SEZIONE RICONOSCIMENTI (INTERATTIVA SOLO SU PREMIO SALVADORI) --- */}
          
          <h2 style={{ fontSize: "1.5em", textAlign: "center", color: "#C770F0" }}>
            Riconoscimenti <img src="https://i.imgur.com/Fxtqb6w.png" style={{ height: "50px"}} alt="logo" />
          </h2>
          
          {/* STATO 1: Testo visibile (se NON è cliccato) */}
          {!showSalvadori && (
            <p style={{ textAlign: "center" }}>
              ● <span 
                  className="purple" 
                  onClick={() => setShowSalvadori(true)}
                  style={{ 
                    cursor: "pointer", 
                    textDecoration: "underline", 
                    fontWeight: "bold" 
                  }}
                  title="Clicca per vedere il premio"
                >
                  Premio Salvadori (clicca per visualizzare)
                </span> 
                {" "}per l'<span className="purple">innovazione in ambito lavorativo</span>, conferito il 20/04/2024 dal Ministro dell'Istruzione e delle Pari Opportunità <span className="purple">Niccolò Salvadori</span>
            </p>
          )}

          {/* STATO 2: Immagine visibile (se è cliccato) */}
          {showSalvadori && (
            <div 
              onClick={() => setShowSalvadori(false)} 
              style={{ cursor: "pointer", textAlign: "center", marginBottom: "20px", animation: "fadeIn 0.5s" }}
            >
              <img 
                src="https://i.imgur.com/4YRXGNH.png" 
                alt="Premio Salvadori" 
                style={{ 
                  maxWidth: "100%", 
                  borderRadius: "8px", 
                  boxShadow: "0 4px 15px rgba(0,0,0,0.5)" 
                }} 
              />
              <div style={{ fontSize: "0.8rem", color: "#ccc", marginTop: "5px" }}>
                (Clicca l'immagine per chiudere)
              </div>
            </div>
          )}

        </blockquote>
      </Col>
    </Row>
  );
}

export default PoliticaCard;
